exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".money-div-global[data-v-8249ac14]{max-width:4rem}hr[data-v-8249ac14]{margin-bottom:2rem}h1[data-v-8249ac14]{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8249ac14","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/loja/vue-components/TabelaPrecos.vue
// module id = 296
// module chunks = 1